module.exports = __webpack_public_path__ + "static/budget-h1-banner-2b01b8507eff7496ecb68f229817e545.png";